function sleep(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms))
}
const getConfig = () => global.CONFIG
export { sleep, getConfig }
